import React from "react";
import "../Styles/SpecialistScroller.css"; // separate styling for card if you want
import linkedinIcon from "../Images/LinkedIn.png";

const SpecialistCard = ({ name, specialty, image, linkedin }) => {
  return (
    <div className="specialist-card">
      <img src={image} alt={name} />
      <a
        href={linkedin}
        className="linkedin-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={linkedinIcon} alt="LinkedIn" />
      </a>
      <div className="doctor-info">
        <h4>{name}</h4>
        <p>{specialty}</p>
      </div>
    </div>
  );
};

export default SpecialistCard;
